export var DistributionPanelType;
(function (DistributionPanelType) {
    DistributionPanelType["US_VERTICAL_SPLIT_PHASE"] = "US_VERTICAL_SPLIT_PHASE";
    DistributionPanelType["US_VERTICAL_THREE_PHASE"] = "US_VERTICAL_THREE_PHASE";
    DistributionPanelType["EU_HORIZONTAL_SINGLE_PHASE"] = "EU_HORIZONTAL_SINGLE_PHASE";
    DistributionPanelType["HIGH_LEG_DELTA_NETWORK"] = "HIGH_LEG_DELTA_NETWORK";
})(DistributionPanelType || (DistributionPanelType = {}));
// TODO: investage if TRIPLE_PHASE is needed
export var EnergySource;
(function (EnergySource) {
    EnergySource["SINGLE_PHASE"] = "SINGLE_PHASE";
    EnergySource["SPLIT_PHASE"] = "SPLIT_PHASE";
    EnergySource["TRIPLE_PHASE"] = "TRIPLE_PHASE";
    EnergySource["THREE_PHASE"] = "THREE_PHASE";
})(EnergySource || (EnergySource = {}));
export var EnergySourceLabel;
(function (EnergySourceLabel) {
    EnergySourceLabel["SINGLE_PHASE"] = "Single Phase";
    EnergySourceLabel["SPLIT_PHASE"] = "Split Phase";
    EnergySourceLabel["TRIPLE_PHASE"] = "Triple Phase";
    EnergySourceLabel["THREE_PHASE"] = "Three Phase";
})(EnergySourceLabel || (EnergySourceLabel = {}));
export const mapMainBreakerPoleToPhase = {
    1: EnergySourceLabel.SINGLE_PHASE,
    2: EnergySourceLabel.SPLIT_PHASE,
    3: EnergySourceLabel.TRIPLE_PHASE,
};
export const PhaseLabels = {
    0: 'AUTO',
    1: 'L1',
    2: 'L2',
    3: 'L3',
    4: 'L1-L2',
    5: 'L2-L3',
    6: 'L3-L1',
};
